import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "@/lib/site";

export default function FloatingActions() {
  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      <a
        href={`https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(
          "Hi Vinodha Diagnostics, I'd like to book an appointment."
        )}`}
        target="_blank"
        rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="float-whatsapp-btn"
        className="wa-pulse grid place-items-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1DA851] text-white shadow-lg transition-colors"
      >
        <MessageCircle className="w-6 h-6" strokeWidth={2.2} />
      </a>
      <a
        href={`tel:${SITE.phoneRaw}`}
        aria-label="Call now"
        data-testid="float-call-btn"
        className="grid place-items-center w-14 h-14 rounded-full bg-[#0369A1] hover:bg-[#0284C7] text-white shadow-lg transition-colors"
      >
        <Phone className="w-6 h-6" strokeWidth={2.2} />
      </a>
    </div>
  );
}
